import { ROUTES } from '@crm/shared/routes';

const BACK_NAVIGATION_LABEL_KEYS: Record<string, string> = {
    [ROUTES.DEALS]: 'crm.deals.page.title',
    [ROUTES.POSTPONED_DEALS]: 'crm.postponedPage.title',
    [ROUTES.LOST_DEALS]: 'crm.lostPage.title',
    [ROUTES.IN_WORK_OR_FINISHED_DEALS]: 'crm.inWorkOrFinishedPage.title',
};

export const getBackNavigationLabelKey = (route?: string) =>
    BACK_NAVIGATION_LABEL_KEYS[route ?? ROUTES.DEALS] ??
    BACK_NAVIGATION_LABEL_KEYS[ROUTES.DEALS];
